import { Link } from '@lokalise/louis';

import { Container, Heading, Paragraph } from './styles';

interface DownloadLimitProps {
    canModifyBilling: boolean;
}

const DownloadLimit = ({ canModifyBilling }: DownloadLimitProps) => (
    <Container>
        <Heading>Upgrade required</Heading>
        <Paragraph>
            {canModifyBilling ? (
                <>
                    You’re now using more keys, projects, or seats than your plan allows.{' '}
                    <Link href="/team/subscription">Upgrade now</Link>.
                </>
            ) : (
                'You’re now using more keys, projects, or seats than your plan allows. Please contact your team owner(-s) or biller(-s).'
            )}
        </Paragraph>
    </Container>
);

export default DownloadLimit;
